export default __webpack_public_path__ + "static/media/female_heart-01.f7415ece.png";